export default __webpack_public_path__ + "static/media/pos-pro-15.4e03ca40.jpg";